import * as React from 'react';
import {observer} from 'mobx-react';
import * as classnames from 'classnames/bind';
import {action, observable} from "mobx";
import {ButtonSize, ButtonStyle, WSPButton} from "@mintdata-wsp/wsp/ui/components/general/WSPButton";
import {Row} from "@mintdata-wsp/wsp/ui/components/forms/Row";
import {Input, InputSize, InputStyle} from "@mintdata-wsp/wsp/ui/components/forms/Input";
import bind from "bind-decorator";
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';

const styles = require('./EditSpace.less');
const cx = classnames.bind(styles);

export interface CreateSpaceProps
{
    onClose:() => void;
    onCreate:(name:string) => void;
    className?:string;
    initialValue?:string;
    buttonTitle:string;
    isNew?:boolean;
}

@observer
export class EditSpace extends React.Component<CreateSpaceProps, any>
{
    @observable
    private _viewNewSpace:boolean = false;

    @observable
    private _newName:string = '';

    @action.bound
    _inputOnChange(newValue:string)
    {
        this._newName = newValue;
    }

    @bind
    _buttonCreateSpace()
    {
        const {onCreate} = this.props;

        onCreate(this._newName.trim());
    }

    @bind
    _buttonCloseCreateSpace()
    {
        const {onClose} = this.props;

        onClose();
    }

    render()
    {
        const {className, buttonTitle, initialValue, isNew} = this.props;

        return  (
            <Row className={cx('createSpace', className)}>

                <Input
                    className={cx('createSpaceInput', {isNew})}
                    style={InputStyle.Simple}
                    size={isNew ? InputSize.Medium : InputSize.Small}
                    placeholder={'Space name'}
                    initialValue={initialValue}
                    isInitiallyFocused={true}
                    isInitiallySelected={true}
                    onChange={this._inputOnChange}
                    onEnterKey={this._buttonCreateSpace}
                    />

                <WSPButton
                    className={cx('createSpaceButton')}
                    caption={buttonTitle}
                    style={ButtonStyle.Simple}
                    size={ButtonSize.Small}
                    onClick={this._buttonCreateSpace}
                    isDisabled={this._newName.trim() === ''}
                />

                <WSPButton
                    className={cx('createSpaceClose')}
                    icon={MDIcons.common.Close}
                    style={ButtonStyle.SimpleSecondary}
                    onClick={this._buttonCloseCreateSpace}
                />

            </Row>
        );
    }
}





